/**
 * Faz 9 (yapay zekâ, öneriler, talep tahmini) arayüz metinleri — Arapça. Bkz. ai.tr.ts (anahtar yapısı) ve ai.en.ts;
 * terimler docs/I18N_GLOSSARY.md ve docs/faz-8/CEVIRI_TERIMLERI.md.
 */
export const aiAr = {
  ui: {
    nav: {
      group: 'الذكاء الاصطناعي',
      settings: 'إعدادات الذكاء الاصطناعي',
      recommendations: 'توصيات المنتجات',
      forecast: 'توقع الطلب',
      studio: 'استوديو المحتوى',
      copilot: 'Copilot (مساعد الأعمال)',
      seo: 'اقتراحات SEO',
      ltv: 'القيمة المتوقعة للعميل',
      youtube: 'مقاطع فيديو YouTube',
    },
    availability: {
      ready: 'جاهز',
      not_configured: 'يتطلب الإعداد',
      disabled: 'متوقف (بانتظار موافقة المالك)',
      budget_exhausted: 'تم بلوغ الحد الشهري',
      daily_limit: 'تم بلوغ الحد اليومي للطلبات',
    },
    purposes: {
      product_description: 'وصف المنتج',
      merchant_title: 'عنوان منتج Google',
      translation: 'الترجمة',
      article_plan: 'مخطط المقال',
      article_headings: 'عناوين المقال',
      article_draft: 'مسودة المقال',
      article_meta: 'عنوان SEO والوصف التعريفي',
      alt_text: 'النص البديل للصورة',
      image: 'إنشاء الصور',
      email_draft: 'مسودة بريد إلكتروني',
      ad_copy: 'نص إعلاني',
      ad_suggestions: 'توصيات الإعلانات',
      support_reply: 'مسودة رد الدعم',
      copilot: 'Copilot',
    },
    requestStatus: { pending: 'قيد التنفيذ', ok: 'مكتمل', error: 'خطأ' },
    providerNames: { anthropic: 'Anthropic Claude', openai: 'OpenAI Images' },
    recommendations: {
      statusTitle: 'الحالة',
      statusLead:
        'لا تستخدم التوصيات الذكاء الاصطناعي وهي مجانية: تُحسب كل ليلة في الساعة 04:25 من الطلبات الفعلية المدفوعة في المتجر. وإذا كانت البيانات غير كافية فلا يظهر القسم المعني في واجهة المتجر.',
      run: 'احسب الآن',
      ran: 'الطلبات المحلَّلة: {{orders}}، والعلاقات المحفوظة: {{pairs}}.',
      stats: 'العلاقات: {{pairs}} · منتجات لها توصيات: {{products}}',
      runsTitle: 'آخر عمليات الحساب',
      when: 'الوقت',
      trigger: 'بدأها',
      scheduled: 'مهمة ليلية',
      manualBy: 'يدويًا ({{name}})',
      orders: 'الطلبات',
      pairsKept: 'العلاقات المحفوظة / المكتشفة',
      result: 'النتيجة',
      status: { ok: 'مكتمل', error: 'خطأ' },
      noStore: 'لا يوجد متجر',
      noStoreLead: 'تُحسب التوصيات لكل متجر على حدة. أنشئ متجرًا أولًا من المنشأة ← المتاجر.',
      noRuns: 'لم تُجرَ أي عملية حساب بعد.',
      settingsTitle: 'الإعدادات',
      toggles: {
        alsoBought: 'صفحة المنتج: «من اشترى هذا المنتج اشترى أيضًا»',
        cart: 'السلة: «قد ترغب أيضًا في إضافة»',
        replenishment: 'حسابي: «حان وقت إعادة الشراء»',
        includeB2b: 'احتساب طلبات الموزّعين أيضًا',
      },
      toggleHints: {
        alsoBought: 'منتجات تُشترى كثيرًا في الطلب نفسه مع هذا المنتج (لا تُكرَّر المنتجات المكمّلة).',
        cart: 'منتجات تُشترى كثيرًا مع منتجات السلة؛ ولا تُعرض المنتجات الموجودة في السلة.',
        replenishment: 'التاريخ التقديري لإعادة شراء المنتجات التي تُشترى بانتظام (يظهر للعميل نفسه فقط).',
        includeB2b: 'قد تُشوّه مشتريات الجملة علاقات التجزئة؛ متوقف افتراضيًا.',
      },
      windowDays: 'الفترة المحلَّلة (بالأيام)',
      minPairBuyers: 'الحد الأدنى للمشترين المختلفين',
      minPairBuyersHint:
        'لا تُستخدم العلاقة إلا إذا ظهر المنتجان معًا في طلبات هذا العدد على الأقل من العملاء المختلفين (حتى لا يمكن استنتاج مشتريات عميل واحد من التوصيات). 2 على الأقل.',
      minConfidence: 'الحد الأدنى للثقة (%)',
      minConfidenceHint:
        'نسبة مشتري المنتج الذين اشتروا المنتج الآخر أيضًا. تُستبعد العلاقات ذات الثقة المنخفضة لأنها قد تكون مصادفة.',
      maxPerProduct: 'الحد الأقصى للتوصيات لكل منتج',
      save: 'حفظ الإعدادات',
      saved: 'تم حفظ الإعدادات. يسري التغيير من عملية الحساب التالية.',
      pairsTitle: 'أقوى العلاقات',
      pairsLead:
        'أقوى علاقة لكل منتج. الثقة: نسبة مشتري المنتج الذين اشتروا الآخر أيضًا. الرفع (Lift): كم مرة يُشتريان معًا أكثر مما تقتضيه المصادفة (أكبر من 1).',
      product: 'المنتج',
      related: 'يُشترى معه',
      buyers: 'المشترون المختلفون',
      confidence: 'الثقة',
      lift: 'الرفع (Lift)',
      noPairs: 'لا توجد توصيات بعد',
      noPairsLead:
        'تظهر التوصيات تلقائيًا عند تراكم طلبات كافية (عدة عملاء مختلفين يشترون المنتجين نفسيهما معًا).',
    },
    forecast: {
      lead: 'لا يستخدم الذكاء الاصطناعي: يُحسب عند كل فتح من المبيعات الأسبوعية للطلبات الفعلية المدفوعة وغير الملغاة. تُخصم من الكمية المقترحة الكميات التي لم تُستلم بعد في أوامر الشراء المفتوحة. لا يُراعى أثر المواسم والحملات؛ ولا يُنشئ أوامر شراء.',
      counts: {
        stockout: 'نفد المخزون',
        reorder: 'حان وقت الطلب',
        on_order: 'تم الطلب',
        expiry_risk: 'خطر انتهاء الصلاحية',
        overstock: 'مخزون زائد',
        ok: 'كافٍ',
        no_sales: 'لا مبيعات',
      },
      accuracy: 'خطأ التوقع في آخر 4 أسابيع (WAPE): {{pct}}% · المتغيرات: {{count}}',
      accuracyNone: 'يلزم سجل مبيعات لا يقل عن 8 أسابيع لقياس الدقة.',
      totalSuggested: 'إجمالي الطلب المقترح: {{count}} قطعة',
      totalOnOrder: 'قيد التوريد والطلب: {{count}} قطعة',
      filterStatus: 'الحالة',
      all: 'الكل',
      search: 'ابحث عن منتج أو SKU',
      csv: 'تنزيل CSV',
      product: 'المنتج',
      sold28: 'آخر 28 يومًا',
      daily: 'التوقع اليومي',
      available: 'المخزون المتاح للبيع',
      onOrder: 'قيد التوريد',
      requestedNote: '{{count}} قيد الطلب',
      cover: 'مدة الكفاية',
      coverDays: '{{days}} يومًا',
      suggested: 'الطلب المقترح',
      status: 'الحالة',
      method: 'الطريقة',
      methods: {
        none: 'لا مبيعات',
        new: 'منتج جديد (متوسط)',
        ses: 'منتظم (التمهيد الأُسّي)',
        croston: 'متقطع (Croston)',
      },
      expiry: 'خطر انتهاء الصلاحية: الدفعة {{lot}} بتاريخ {{date}} — قد لا تُباع {{count}} قطعة',
      excluded: 'مستبعد من التوقع',
      customSafety: 'مخزون أمان مخصص: {{days}} يومًا',
      leadLine: 'مدة التوريد {{days}} يومًا ({{source}})',
      leadSources: {
        variant: 'خاصة بالمنتج',
        supplier: 'من المورّد',
        supplierNamed: 'المورّد: {{name}}',
        default: 'افتراضية',
      },
      adjust: 'ضبط',
      empty: 'لا توجد منتجات لعرضها',
      emptyLead: 'تكون القائمة فارغة عند عدم وجود متغيرات منتجات نشطة أو عدم تطابق أي منتج مع المرشّح.',
      variantTitle: '{{product}} — إعداد التوقع',
      leadTime: 'مدة التوريد (بالأيام)',
      safety: 'مخزون الأمان (بالأيام)',
      defaultHint: 'إذا تُرك فارغًا يُستخدم الإعداد الافتراضي للمنشأة ({{days}} يومًا).',
      supplierHint: 'إذا تُرك فارغًا تُستخدم مدة توريد مورّد آخر أمر شراء ({{days}} يومًا).',
      exclude: 'استبعاد من التوقع (منتج لمرة واحدة أو أُوقف بيعه)',
      variantSaved: 'تم حفظ إعداد المتغير.',
      settingsTitle: 'الإعدادات الافتراضية',
      historyWeeks: 'السجل المحلَّل (بالأسابيع)',
      defaultLead: 'مدة التوريد الافتراضية (بالأيام)',
      defaultSafety: 'مخزون الأمان الافتراضي (بالأيام)',
      reviewDays: 'فترة المراجعة (بالأيام)',
      reviewHint:
        'تهدف الكمية المقترحة إلى أن يكفي المخزون الطلب طوال مدة التوريد + أيام الأمان + هذه الفترة.',
      overstockDays: 'حد المخزون الزائد (بالأيام)',
      includeB2b: 'إدراج طلبات الموزّعين في حساب الطلب المتوقع',
      save: 'حفظ الإعدادات الافتراضية',
      saved: 'تم حفظ الإعدادات الافتراضية.',
    },
    studio: {
      lead: 'جهّز المقال عبر عملية من 27 خطوة: من الموضوع والمصادر إلى المخطط، ومن المسودة إلى SEO والصور، ومن فحص الجودة إلى الأداء بعد النشر. خطوات الذكاء الاصطناعي اختيارية؛ ويمكن ملء كل حقل يدويًا. يتم النشر واعتماد المحرر والطبيب البيطري من شاشة المدونة.',
      create: 'مشروع مقال جديد',
      createTitle: 'مشروع مقال جديد',
      createSubmit: 'إنشاء المشروع',
      filter: 'عرض',
      filters: { active: 'المشاريع الجارية', exported: 'المنقولة إلى المدونة', archived: 'الأرشيف' },
      statuses: { draft: 'قيد الإعداد', exported: 'نُقل إلى المدونة', archived: 'مؤرشف' },
      empty: 'لا توجد مشاريع مقالات بعد',
      emptyLead: 'ابدأ بـ«مشروع مقال جديد» واكتب الموضوع والجمهور المستهدف.',
      words: '{{count}} كلمة',
      updated: '{{date}} · {{name}}',
      healthBadge: 'محتوى صحي',
      aiAssisted: 'بمساعدة الذكاء الاصطناعي',
      back: 'جميع المشاريع',
      save: 'حفظ',
      saved: 'تم حفظ المشروع.',
      unsaved: 'توجد تغييرات غير محفوظة.',
      saveFirst: 'احفظ التغييرات أولًا.',
      stepsTitle: 'العملية: {{done}} / {{total}} خطوة',
      stepDone: 'مكتملة',
      stepOpen: 'قيد الانتظار',
      stepAi: 'استُخدم الذكاء الاصطناعي في هذه الخطوة',
      steps: {
        topic: 'الموضوع',
        audience: 'الجمهور المستهدف',
        market: 'الدولة واللغة المستهدفتان',
        keyword: 'الكلمة المفتاحية',
        intent: 'نية البحث',
        sources: 'المصادر',
        duplicates: 'فحص التكرار',
        plan: 'مخطط المقال',
        headings: 'عناوين H2/H3',
        draft: 'المسودة',
        sourceCheck: 'التحقق من المصادر',
        internalLinks: 'الروابط الداخلية',
        relatedProducts: 'منتجات ذات صلة',
        seoTitle: 'عنوان SEO',
        metaDescription: 'الوصف التعريفي (Meta)',
        slug: 'الاسم المختصر (Slug)',
        category: 'الفئة',
        tags: 'الوسوم',
        schema: 'البيانات المنظَّمة',
        cover: 'صورة الغلاف',
        images: 'صور المحتوى',
        altText: 'النصوص البديلة',
        quality: 'فحص الجودة',
        approval: 'اعتماد المحرر والطبيب البيطري',
        schedule: 'النشر / الجدولة',
        performance: 'متابعة الأداء',
        updates: 'اقتراحات التحديث',
      },
      sec: {
        brief: 'الموضوع والهدف (الخطوات 1–5)',
        research: 'المصادر وفحص التكرار (الخطوات 6 و7 و11)',
        outline: 'المخطط والعناوين (الخطوتان 8–9)',
        draft: 'المسودة والروابط الداخلية والمنتجات ذات الصلة (الخطوات 10 و12–13)',
        seo: 'SEO (الخطوات 14–19)',
        images: 'الصور (الخطوات 20–22)',
        quality: 'فحص الجودة (الخطوة 23)',
        publish: 'الاعتماد والنشر (الخطوتان 24–25)',
        performance: 'الأداء والتحديث (الخطوتان 26–27)',
      },
      f: {
        title: 'العنوان المبدئي',
        topic: 'الموضوع',
        topicHint:
          'السؤال الذي يجيب عنه المقال أو الموضوع الذي يتناوله (مثل: «كيف تختار مكمّل أوميغا-3 لقطتك»).',
        audience: 'الجمهور المستهدف',
        country: 'الدولة المستهدفة',
        countryHint: 'رمز الدولة المكوّن من حرفين (TR وDE…).',
        keyword: 'الكلمة المفتاحية',
        keywordPool: 'اختر من مجمّع الكلمات المفتاحية',
        keywordNone: 'لم تُحدَّد (اكتبها يدويًا)',
        intent: 'نية البحث',
        intentNone: 'غير محددة',
        health: 'محتوى صحي / مكمّلات غذائية (يتطلب اعتماد الطبيب البيطري)',
        sourceUrl: 'رابط المصدر',
        sourceTitle: 'اسم المصدر',
        sourceNote: 'ملاحظة',
        plan: 'المخطط',
        headings: 'العناوين',
        headingLevel: 'المستوى',
        headingText: 'العنوان',
        draft: 'المسودة (Markdown)',
        draftHint:
          '{{count}} كلمة. ## لعناوين H2، و### لعناوين H3؛ و[النص](/urun/slug) للروابط الداخلية. لا يُنفَّذ كود HTML الخام.',
        relatedProducts: 'منتجات ذات صلة',
        seoTitle: 'عنوان SEO',
        slug: 'الاسم المختصر (Slug)',
        metaDescription: 'الوصف التعريفي (Meta)',
        category: 'فئة المدونة',
        categoryNone: 'بدون فئة',
        tags: 'الوسوم',
        tagsHint: 'افصل بينها بفواصل (10 كحد أقصى).',
        cover: 'صورة الغلاف',
        coverAlt: 'النص البديل للغلاف',
        images: 'صور المحتوى',
        imageReplace: 'استبدال الصورة',
        imageAlt: 'النص البديل',
        imageAdd: 'إضافة صورة',
        aiDisclosure: 'إضافة ملاحظة «أُعدّ بمساعدة الذكاء الاصطناعي» في نهاية المقال',
      },
      intents: {
        informational: 'يبحث عن معلومات',
        commercial: 'يقارن بين الخيارات',
        transactional: 'يريد الشراء',
        navigational: 'يبحث عن صفحة معيّنة',
      },
      sourcesLead:
        'أضف المصادر التي يستند إليها المقال. لا يجوز للذكاء الاصطناعي الاستشهاد إلا بهذه المصادر؛ ولا يمكنه اختلاق مصادر أو إحصاءات أو دراسات. تُنقل المصادر إلى قسم «المراجع» في مقال المدونة.',
      addSource: 'إضافة مصدر',
      removeSource: 'إزالة المصدر',
      verify: 'التحقق من المصادر',
      verified: 'تم فحص المصادر.',
      checkedAt: 'فُحص في {{date}}',
      sourceStatus: {
        ok: 'يمكن الوصول إليه',
        unreachable: 'تعذّر الوصول إليه',
        blocked: 'محظور (شبكة داخلية)',
        http_error: 'أعادت الصفحة خطأ',
        not_html: 'ليس صفحة ويب',
        invalid_url: 'رابط غير صالح',
      },
      duplicatesTitle: 'فحص التكرار',
      duplicatesNotChecked: 'لم يُفحص بعد.',
      duplicatesNone: 'لا توجد في المتجر مقالات أو صفحات بعناوين مشابهة.',
      duplicatesChecked: 'تم فحص التكرار.',
      similarity: 'تشابه بنسبة {{pct}}%',
      checkDuplicates: 'البحث عن محتوى مشابه',
      aiPlan: 'المخطط والعناوين بالذكاء الاصطناعي',
      aiDraft: 'مسودة بالذكاء الاصطناعي',
      aiMeta: 'اقتراح SEO بالذكاء الاصطناعي',
      aiDone: 'تم حفظ اقتراح الذكاء الاصطناعي. راجعه وعدّله.',
      overwrite: 'استبدال المحتوى',
      overwriteConfirm:
        'يحتوي هذا الحقل على محتوى. سيحلّ اقتراح الذكاء الاصطناعي محلّ المحتوى الحالي (لا يُحتفظ بالنسخة القديمة في سجل المشروع). هل تريد المتابعة؟',
      claimsFound: 'عبارات ادعاء صحي في الاقتراح: {{count}}؛ صحّحها قبل النشر:',
      masked: 'بيانات شخصية أُخفيت قبل الإرسال إلى المزوّد: {{count}}.',
      truncated: 'اقتُطع الرد عند حد الطول؛ تحقّق من نهايته.',
      addHeading: 'إضافة عنوان',
      removeHeading: 'إزالة العنوان',
      linksTitle: 'الروابط الداخلية',
      linksNone: 'لم تُختر روابط داخلية بعد.',
      linkTypes: { product: 'منتج', category: 'فئة', post: 'مقال' },
      removeLink: 'إزالة رابط {{title}}',
      suggest: 'جلب اقتراحات من المتجر',
      suggestNone: 'لم يُعثر على منتج أو فئة أو مقال منشور يطابق الموضوع.',
      add: 'إضافة',
      added: 'تمت الإضافة',
      relatedSuggested: 'المنتجات المقترحة:',
      chars: '{{count}} / {{max}} حرفًا',
      schemaNote:
        'تُنشأ البيانات المنظَّمة (BlogPosting) تلقائيًا من العنوان والوصف والغلاف والتواريخ عند نشر مقال المدونة.',
      coverSet: 'تم اختيار الغلاف',
      imagesNote:
        'يصبح الغلاف صورة غلاف مقال المدونة؛ وتوضع صور المحتوى في المسودة حيث تريد عبر «إضافة إلى المسودة» وتنتقل إلى المقال عند النقل.',
      aiCover: 'صورة غلاف بالذكاء الاصطناعي',
      aiImage: 'صورة محتوى بالذكاء الاصطناعي',
      imagePrompt: 'ماذا تريد أن تُظهر الصورة؟',
      imagePromptHint:
        'اكتب وصفًا قصيرًا وملموسًا (مثل: «كلب غولدن ريتريفر سعيد يركض في حديقة، ضوء الصباح»). لا تُضاف إلى الصورة نصوص أو شعارات أو علامات تجارية أو أشخاص يمكن التعرّف عليهم.',
      imageStyle: 'النمط',
      imageStyles: { photo: 'صورة فوتوغرافية واقعية', illustration: 'رسم توضيحي' },
      imageSize: 'المقاس',
      imageSizes: { '1536x1024': 'أفقي (3:2)', '1024x1024': 'مربع', '1024x1536': 'عمودي (2:3)' },
      imageCost: 'طلب مدفوع؛ لا يتجاوز الإنفاق لكل صورة الحد الأعلى المحدد في إعدادات الذكاء الاصطناعي.',
      generate: 'إنشاء الصورة',
      imageDone: 'تم إنشاء الصورة وإضافتها. اكتب نصها البديل ثم احفظ.',
      aiGenerated: 'مُنشأة بالذكاء الاصطناعي',
      aiAlt: 'نص بديل بالذكاء الاصطناعي',
      altDone: 'كُتب النص البديل المقترح في الحقل؛ قارنه بالصورة ثم احفظ.',
      insertToDraft: 'إضافة إلى المسودة',
      inserted: 'أُضيفت الصورة إلى نهاية المسودة؛ انقلها إلى الموضع الذي تريده ثم احفظ.',
      provenance: 'المصدر والترخيص',
      provenanceTitle: 'مصدر الصورة وترخيصها',
      provenanceSource: 'المصدر',
      provenanceSources: {
        own: 'تصويرنا / تصميمنا الخاص',
        licensed: 'مرخّصة (من مكتبة صور)',
        supplier: 'المورّد / العلامة التجارية',
        other: 'أخرى',
        ai_generated: 'مُنشأة بالذكاء الاصطناعي',
      },
      provenanceNone: 'لم تُدخل معلومات المصدر.',
      provenanceLicense: 'الترخيص',
      provenanceLicenseHint: 'مثل: «ترخيص قياسي لصورة من مكتبة صور»، «CC BY 4.0».',
      provenanceCredit: 'حقوق النشر / الإسناد',
      provenanceUrl: 'رابط المصدر',
      provenanceSaved: 'تم حفظ معلومات المصدر.',
      provenanceAiLocked:
        'لا يمكن تغيير مصدر الصورة المُنشأة بالذكاء الاصطناعي؛ وتُعرض في واجهة المتجر مع ملاحظة «صورة مُنشأة بالذكاء الاصطناعي».',
      provenanceModel: 'النموذج: {{model}} · {{date}}',
      qualityStatus: { pass: 'سليم', warn: 'تحذير', fail: 'ناقص' },
      quality: {
        title_length: 'طول العنوان {{length}} حرفًا (الموصى به 30–70).',
        meta_length: 'طول الوصف التعريفي {{length}} حرفًا (الموصى به 70–170).',
        slug: 'تم تحديد الاسم المختصر (Slug).',
        word_count: 'عدد كلمات المسودة: {{words}} (الحد الأدنى {{min}}).',
        h1_in_body: 'لا يوجد H1 في المسودة (يُضاف العنوان بشكل منفصل).',
        h2_count: 'عناوين H2: {{count}} (2 على الأقل).',
        keyword_title: 'الكلمة المفتاحية موجودة في العنوان.',
        keyword_intro: 'الكلمة المفتاحية موجودة في فقرة المقدمة.',
        keyword_heading: 'الكلمة المفتاحية موجودة في عنوان فرعي واحد على الأقل.',
        keyword_density: 'كثافة الكلمة المفتاحية {{percent}}% (3% كحد أقصى).',
        keyword_missing: 'لم تُحدَّد كلمة مفتاحية.',
        internal_links: 'الروابط الداخلية في المسودة: {{count}} (يوصى برابط داخلي واحد على الأقل).',
        sources_missing: 'لم تُضف مصادر (إلزامية في المحتوى الصحي).',
        sources_broken: 'مصادر يتعذّر الوصول إليها: {{count}}.',
        sources_unchecked: 'مصادر لم يُتحقق منها بعد: {{count}}.',
        sources_ok: 'مصادر تم التحقق منها: {{count}}.',
        cover: 'صورة الغلاف ونصها البديل.',
        image_alt: 'صور ينقصها النص البديل: {{count}}.',
        health_claims: 'عبارات تدّعي الوقاية من الأمراض أو علاجها: {{count}}.',
        duplicates_unchecked: 'لم يُجرَ فحص التكرار.',
        duplicates_similar: 'يوجد محتوى مشابه جدًا: {{title}}.',
        duplicates_ok: 'لا يوجد محتوى مشابه جدًا.',
        expert_review: 'سيلزم اعتماد المراجع البيطري المختص قبل النشر.',
      },
      qualityAfterSave: 'يُجرى فحص الجودة على النسخة المحفوظة.',
      publishLead:
        'ينشئ النقل مسودة في المدونة أو يحدّث المسودة المرتبطة. يتم النشر واعتماد المحرر والمراجع البيطري المختص والنشر المجدول من شاشة المدونة؛ ولا يتغير المقال المنشور بالنقل.',
      export: 'نقل إلى مقال المدونة',
      reexport: 'تحديث مسودة المدونة',
      exported: 'تم تحديث مسودة المدونة.',
      openPost: 'فتح مقال المدونة',
      archive: 'أرشفة المشروع',
      archiveConfirm: 'هل تريد أرشفة المشروع؟ لن يتأثر مقال المدونة المرتبط.',
      archivedDone: 'تمت أرشفة المشروع.',
      perf: {
        not_exported: 'يظهر الأداء بعد نقل المقال إلى المدونة ونشره.',
        not_live: 'مقال المدونة غير منشور بعد.',
        no_permission: 'لا تملك صلاحية عرض بيانات Search Console.',
        not_linked: 'Search Console غير مرتبط (يتطلب الإعداد): اربطه من شاشة اتصالات Google.',
        no_data: 'لم تتم مزامنة بيانات Search Console بعد.',
      },
      perfRange: 'أحدث البيانات: {{from}} – {{to}}',
      perfPeriod: 'الفترة',
      periods: { current: 'آخر 28 يومًا', previous: 'الـ28 يومًا السابقة' },
      clicks: 'النقرات',
      impressions: 'مرات الظهور',
      ctr: 'نسبة النقر إلى الظهور',
      position: 'متوسط الترتيب',
      notComparable: 'بيانات الفترة السابقة غير كافية للمقارنة.',
      queries: 'عمليات البحث التي أوصلت إلى هذا المقال (آخر 28 يومًا)',
      queryStats: '· النقرات: {{clicks}} · مرات الظهور: {{impressions}}',
      suggestionsTitle: 'اقتراحات التحديث',
      suggestionsNone: 'لا توجد اقتراحات حاليًا.',
      suggestions: {
        stale: 'لم يُحدَّث المقال منذ {{days}} يومًا؛ راجع المعلومات والمصادر.',
        traffic_drop:
          'انخفضت النقرات مقارنةً بالـ28 يومًا السابقة ({{previous}} ← {{current}}). تحقّق من عمليات البحث ومدى حداثة المحتوى.',
        low_ctr:
          'نسبة النقر إلى الظهور {{ctr}}% (مرات الظهور: {{impressions}}): اجعل عنوان SEO والوصف التعريفي أوضح.',
        near_first_page:
          'متوسط الترتيب {{position}}: قريب من الصفحة الأولى. وسّع المحتوى وأضف إليه روابط داخلية من الصفحات ذات الصلة.',
        missing_queries: 'عمليات بحث لا يغطيها المقال: {{queries}}. أضف قسمًا يجيب عنها إن كان ذلك مناسبًا.',
        sources_recheck: 'لم يُتحقق من المصادر منذ 6 أشهر؛ افحص الروابط مجددًا.',
      },
    },
    drafts: {
      copy: 'نسخ',
      copied: 'تم النسخ.',
      generate: 'إنشاء مسودة',
      again: 'إعادة الإنشاء',
      apply: 'تطبيق على الحقول',
      applied: 'كُتبت المسودة في النموذج؛ راجعها ثم احفظ.',
      reviewNote:
        'هذه مسودة: استُخدمت البيانات المحفوظة للمنتج فقط. اقرأها قبل النشر؛ ويخضع المحتوى الصحي لاعتماد الطبيب البيطري.',
      productDescription: 'مسودة وصف بالذكاء الاصطناعي',
      productLead:
        'يُكتب الوصفان القصير والطويل من البيانات المحفوظة للمنتج (الاسم، العلامة التجارية، نوع الحيوان، الفئة، الخصائص، التركيب، الاستخدام، التحذيرات). طلب مدفوع.',
      tone: 'الأسلوب',
      tones: { informative: 'معلوماتي', friendly: 'ودّي' },
      notes: 'نقطة للتركيز عليها (اختياري)',
      translate: 'ترجمة بالذكاء الاصطناعي',
      translateFrom: 'لغة المصدر',
      translated: 'كُتبت الترجمة في النموذج؛ راجعها ثم احفظ.',
      email: 'اقتراح موضوع بالذكاء الاصطناعي',
      goal: 'هدف الحملة',
      goalHint: 'مثل: «التذكير بمنتجات دعم المفاصل في أشهر الشتاء».',
      audience: 'الجمهور المستهدف (اختياري)',
      products: 'المنتجات المميزة (اختياري)',
      subjects: 'اقتراحات الموضوع',
      useAsA: 'استخدامه موضوعًا',
      useAsB: 'استخدامه موضوعًا B',
      preheader: 'النص التمهيدي',
      use: 'استخدام',
      intro: 'فقرة المقدمة',
      introNote: 'يمكنك نسخ فقرة المقدمة إلى نص قالب البريد الإلكتروني.',
      supportReply: 'مسودة رد بالذكاء الاصطناعي',
      replyDone: 'كُتبت مسودة الرد في الحقل؛ اقرأها وعدّلها ثم أرسلها.',
      adSuggestions: 'توصيات الإعلانات',
      adSuggestionsLead:
        'نتائج قائمة على قواعد وفق إيرادات الطلبات الفعلية (مجانية). ويمكنك إن شئت أن يلخّص الذكاء الاصطناعي النتائج بالاعتماد على هذه الأرقام فقط (مدفوع). تتم تغييرات الميزانية والنشر دائمًا عبر طلب تغيير وموافقة.',
      period: 'الفترة',
      lastDays: 'آخر {{days}} يومًا',
      findings: 'عرض النتائج',
      summarize: 'تلخيص بالذكاء الاصطناعي',
      noAdData: 'لا توجد بيانات إعلانية في هذه الفترة. اربط حسابًا إعلانيًا أو ارفع ملف تقرير.',
      noFindings: 'لا توجد نتائج تستدعي الانتباه.',
      findingKinds: {
        no_orders: 'إنفاق بلا طلبات',
        roas_below_1: 'ROAS أقل من 1',
        low_ctr: 'نسبة نقر منخفضة',
        scale_candidate: 'قابل للتوسيع',
        anomaly: 'حالة شاذة',
      },
      anomalies: {
        no_clicks: 'إنفاق بلا نقرات',
        spend_spike: 'قفزة في الإنفاق',
        ctr_drop: 'انخفاض نسبة النقر',
        sync_failed: 'فشل المزامنة',
        sync_stale: 'البيانات غير محدّثة',
      },
      aiSummary: 'ملخص الذكاء الاصطناعي',
      adChangeNote:
        'هذه توصية فقط: لا يُنشأ إعلان ولا تتغير الميزانية أو حالة النشر. للتغيير، أنشئ طلب تغيير وأرسله للموافقة.',
      adCopy: 'مسودة نص إعلاني',
      product: 'المنتج',
      platform: 'المنصة',
      platforms: { google: 'إعلان بحث متجاوب على Google', meta: 'Meta (Facebook / Instagram)' },
      pickProduct: 'اختر منتجًا أولًا.',
      primaryTexts: 'النصوص الأساسية',
      headlines: 'العناوين',
      descriptions: 'الأوصاف',
      maxChars: '{{max}} حرفًا كحد أقصى',
      dropped: 'أسطر أُسقطت لتجاوزها حد الأحرف: {{count}}.',
      adEmpty: 'لم ينتج نص صالح للاستخدام',
      adEmptyLead: 'حاول الإنشاء مرة أخرى.',
    },
    copilot: {
      lead: 'رؤى محسوبة من بيانات نشاطك التجاري (مجانية، بلا ذكاء اصطناعي) ومساعد يجيب باستخدام هذه البيانات. لا يغيّر Copilot أي سجل؛ ولا تُستخدم إلا البيانات التي تملك صلاحية رؤيتها.',
      period: 'الفترة',
      copyReport: 'نسخ كتقرير للإدارة',
      reportTitle: 'ملخص الإدارة ({{from}} – {{to}})',
      insightsTitle: 'الرؤى',
      noInsights: 'لا توجد رؤى بعد',
      noInsightsLead: 'تظهر هنا مع تراكم بيانات المبيعات أو المخزون أو الإعلانات.',
      severity: { good: 'جيد', info: 'معلومة', warn: 'انتباه' },
      sectionsNote: 'أقسام لم تُدرج لعدم امتلاكك الصلاحية: {{hidden}}.',
      sections: {
        stock: 'المخزون',
        seo: 'SEO',
        customers: 'شرائح العملاء',
        ads: 'الإعلانات',
        cost: 'التكلفة والهامش',
        finance: 'صافي الربح',
      },
      insights: {
        no_sales: 'لا توجد طلبات مدفوعة في هذه الفترة ولا في السابقة؛ لا يمكن استخلاص رؤى عن المبيعات.',
        revenue_change:
          'إيرادات المنتجات {{current}} (الفترة السابقة {{previous}}، التغيّر {{change}}%)؛ الطلبات: {{orders}} (السابقة {{previousOrders}}).',
        aov_change: 'متوسط قيمة الطلب {{current}} (السابق {{previous}}، التغيّر {{change}}%).',
        decline_drivers: 'المنتجات الأكثر إسهامًا في الانخفاض: {{products}}.',
        refund_rate: 'نسبة المرتجعات/الإلغاءات {{rate}}%: راجع أسباب الإرجاع.',
        new_customers: '{{share}}% من الطلبات من عملاء جدد (الطلبات: {{count}}).',
        margin_down:
          'هامش الربح الإجمالي {{previous}}% ← {{current}}%: تحقّق من ارتفاع التكاليف أو الخصومات.',
        margin_unknown: 'تعذّر حساب الهامش: لم تُدخل التكلفة لبعض المنتجات المبيعة.',
        quiet_days:
          'وردت طلبات في {{active}} يومًا فقط من أصل {{days}} يومًا في هذه الفترة؛ وكانت الفترة السابقة أكثر انتظامًا.',
        stock_needs: 'نفد مخزون {{stockout}} من المتغيرات، وحان وقت طلب {{reorder}} منها: {{items}}.',
        expiry_risk: 'يوجد في {{count}} من المتغيرات خطر بقاء مخزون لا يُباع قبل تاريخ انتهاء الصلاحية.',
        seo_not_linked: 'Search Console غير مرتبط؛ لا يمكن حساب فرص SEO.',
        seo_opportunities:
          'عمليات بحث قريبة من الصفحة الأولى لكن نقراتها قليلة (مرات الظهور، الترتيب): {{queries}}.',
        segment_at_risk:
          '{{count}} من العملاء القيّمين على وشك الضياع (مجموعتا RFM «معرّضون للخطر» و«لا يمكن خسارتهم»): فكّر في حملة لاستعادتهم.',
        segment_champions: 'عملاء من مجموعة «الأبطال»: {{count}}؛ ادعُهم إلى برنامج الولاء أو الإحالة.',
        ads_roas: 'الإنفاق الإعلاني {{spend}}، وإيرادات المنتجات من الإعلانات {{revenue}} (ROAS {{roas}}).',
        ads_anomalies: 'حالات شاذة في الإعلانات: {{count}}؛ تحقّق من مركز الإعلانات.',
        net_profit:
          'صافي الربح {{current}} (الفترة السابقة {{previous}}، التغير {{change}}٪)؛ هامش صافي الربح {{margin}}٪.',
        net_profit_partial:
          'حُسب صافي الربح ببيانات ناقصة: مبيعات بلا تكلفة {{revenue}}، و{{shipments}} شحنة بلا تكلفة شحن، و{{payments}} دفعة بلا عمولة (التقارير ← التقرير المالي).',
      },
      salesTitle: 'ملخص المبيعات ({{from}} – {{to}})',
      metric: 'المؤشر',
      current: 'هذه الفترة',
      previous: 'الفترة السابقة',
      metrics: {
        orders: 'الطلبات',
        revenue: 'إيرادات المنتجات (دون ضريبة القيمة المضافة والشحن)',
        refunded: 'المرتجعات / الإلغاءات',
        newCustomers: 'العملاء الجدد',
      },
      topProducts: 'الأكثر مبيعًا',
      profitTitle: 'صافي الربح ({{from}} – {{to}})',
      profitLead:
        'الحساب نفسه في التقرير المالي: دون ضريبة القيمة المضافة، بالليرة التركية. صافي الربح = إجمالي الربح − الشحن − عمولات الدفع − الإعلانات − الاعتراضات الخاسرة − المصاريف التشغيلية.',
      profitMetrics: {
        revenueMinor: 'إيراد المنتجات (دون الضريبة)',
        grossProfitMinor: 'إجمالي الربح',
        shippingMinor: 'تكلفة الشحن',
        feesMinor: 'عمولات الدفع',
        adsMinor: 'الإنفاق الإعلاني',
        disputesMinor: 'الاعتراضات الخاسرة',
        expensesMinor: 'المصاريف التشغيلية',
        netProfitMinor: 'صافي الربح',
        netBps: 'هامش صافي الربح',
      },
      percent: '{{value}}٪',
      askTitle: 'اسأل Copilot',
      askLead:
        'تُبنى الإجابة على البيانات المحسوبة أعلاه فقط (لا تُرسل أسماء العملاء أو بريدهم الإلكتروني أو عناوينهم). إذا لم تتوفر البيانات يذكر Copilot ذلك؛ ولا ينفّذ أي إجراء. كل سؤال طلب مدفوع.',
      conversation: 'المحادثة',
      you: 'أنت',
      copilot: 'Copilot',
      question: 'سؤالك',
      questionHint:
        'مثل: «لماذا انخفضت المبيعات؟»، «ما المنتجات التي يجب أن أجدّد مخزونها؟»، «أعطني 3 توصيات لهذا الشهر.»',
      ask: 'اسأل',
      clear: 'مسح المحادثة',
    },
    seo: {
      lead: 'اقتراحات بلا ذكاء اصطناعي من مجمّع الكلمات المفتاحية وبيانات Search Console: عناقيد تلقائية، وخريطة المواضيع، وعمليات البحث الطويلة (Long-tail)، وفجوات المحتوى، وعناوين منتجات Google.',
      notSynced:
        'لا توجد بيانات Search Console: تبقى أعداد مرات الظهور واقتراحات البحث الطويل فارغة. اربطه من شاشة اتصالات Google.',
      clustersTitle: 'العناقيد التلقائية',
      noProposals: 'لا توجد عناقيد جديدة لاقتراحها.',
      emptyPool: 'مجمّع الكلمات المفتاحية فارغ. أضفها من SEO ← الكلمات المفتاحية.',
      keywordCount: '({{count}} كلمة)',
      applyClusters: 'تطبيق العناقيد المحددة ({{count}})',
      applied: 'تم تحديث العنقود لـ{{count}} من الكلمات المفتاحية.',
      topicsTitle: 'خريطة المواضيع (الصفحة المحورية والمحتوى الداعم)',
      noTopics: 'لا توجد كلمات مفتاحية ضمن عناقيد. طبّق العناقيد أولًا.',
      pillar: 'الكلمة الرئيسية: {{keyword}} ← {{path}}',
      noPage: 'لا توجد صفحة',
      link: {
        yes: 'يرتبط بالصفحة المحورية',
        no: 'الرابط إلى الصفحة المحورية مفقود',
        unknown: 'تعذّر الفحص',
      },
      missingContent: 'كلمات مفتاحية بلا صفحة مستهدفة: {{count}}.',
      longTailTitle: 'عمليات البحث الطويلة (Long-tail)',
      noLongTail: 'لا توجد عمليات بحث خارج المجمّع من 3 كلمات فأكثر وبـ10 مرات ظهور فأكثر.',
      query: 'عبارة البحث',
      pick: 'تحديد {{query}}',
      addToPool: 'إضافة عمليات البحث المحددة ({{count}}) إلى المجمّع',
      added: 'أُضيفت إلى المجمّع.',
      gapsTitle: 'فجوات المحتوى',
      noGaps: 'لا توجد كلمات مفتاحية بلا صفحة مستهدفة.',
      createProject: 'إنشاء مشروع مقال',
      openProject: 'فتح المشروع',
      titlesTitle: 'عناوين منتجات Google',
      titlesLead:
        'العنوان المُرسَل إلى Merchant Center: 150 حرفًا كحد أقصى، والمعلومات المهمة في البداية، مع العلامة التجارية ونوع المنتج، ودون نصوص ترويجية أو أحرف كبيرة بالكامل. إذا تُرك فارغًا يُرسَل اسم المنتج.',
      onlyIssues: 'ذات المشكلات فقط',
      noTitleIssues: 'لا توجد عناوين بها مشكلات.',
      currentTitle: 'العنوان الحالي',
      suggested: 'الاقتراح',
      aiSuggested: 'اقتراح الذكاء الاصطناعي',
      applyTitle: 'تطبيق',
      aiTitle: 'عنوان بالذكاء الاصطناعي',
      resetTitle: 'العودة إلى اسم المنتج',
      titleSaved: 'تم حفظ عنوان Google؛ ويسري من الإرسال التالي للخلاصة (Feed).',
      issues: {
        too_long: 'يتجاوز 150 حرفًا',
        too_short: 'قصير جدًا',
        promo_text: 'يحتوي عبارة ترويجية',
        all_caps: 'أحرف كبيرة بالكامل',
        brand_missing: 'العلامة التجارية مفقودة',
        symbols: 'رموز / رموز تعبيرية غير ضرورية',
        health_claim: 'ادعاء صحي',
      },
    },
    youtube: {
      lead: 'تُقرأ المعلومات العامة لمقاطع فيديو YouTube المستخدمة في المنتجات ومقالات المدونة عبر YouTube Data API (قراءة فقط، حصة يومية مجانية؛ وليس ذكاءً اصطناعيًا). تُضاف في واجهة المتجر معلومات الفيديو لمحركات البحث (الصورة المصغّرة، تاريخ الرفع، المدة)؛ ولا تُعرض في واجهة المتجر مقاطع الفيديو المحذوفة أو المعطّل تضمينها أو المحظورة في تركيا.',
      connectionTitle: 'الاتصال',
      notConfigured:
        'لم يُدخل مفتاح YouTube Data API. تُعرض مقاطع الفيديو في واجهة المتجر كما كانت؛ وتغيب فقط معلومات الفيديو والتحذيرات.',
      connectionError:
        'في المحاولة الأخيرة رُفض مفتاح YouTube أو كانت واجهة API معطّلة. تحقّق من المفتاح في شاشة التكاملات وأعد الاختبار.',
      toIntegrations: 'أدخل المفتاح من شاشة التكاملات',
      connected: 'متصل',
      lastSync: 'آخر مزامنة: {{date}}',
      neverSynced: 'لم تتم المزامنة بعد (تتم كل ليلة في الساعة 05:50).',
      syncNow: 'المزامنة الآن',
      synced: 'مقاطع فيديو حُدّثت معلوماتها: {{count}}.',
      logsTitle: 'آخر عمليات المزامنة',
      outcome: { success: 'ناجحة', failure: 'خطأ', blocked: 'محظورة' },
      logOk: 'مقاطع الفيديو: {{videos}}، الطلبات: {{requests}}',
      videosTitle: 'مقاطع الفيديو المستخدمة',
      noVideos: 'لا توجد مقاطع فيديو YouTube في المنتجات أو مقالات المدونة.',
      summary: 'مقاطع الفيديو: {{count}} · بها مشكلات: {{problems}}',
      onlyIssues: 'ذات المشكلات فقط',
      status: {
        available: 'منشور',
        processing: 'قيد المعالجة',
        not_embeddable: 'غير قابل للتضمين',
        region_blocked: 'محظور في تركيا',
        unavailable: 'محذوف أو خاص',
        unknown: 'لم تُجلب المعلومات',
      },
      problem: {
        not_embeddable: 'عطّل مالك الفيديو التشغيل على المواقع الأخرى؛ لذا لا يُعرض في واجهة المتجر.',
        region_blocked: 'لا يمكن مشاهدة الفيديو في تركيا؛ لذا لا يُعرض في واجهة المتجر.',
        unavailable:
          'حُذف الفيديو أو أُخفي أو رُفض؛ لذا لا يُعرض في واجهة المتجر. أزله من المنتج أو المقال أو استبدله.',
      },
      published: 'النشر: {{date}}',
      open: 'فتح على YouTube',
      usedBy: 'مكان الاستخدام:',
      product: 'المنتج: {{name}}',
      post: 'المقال: {{name}}',
    },
    ltv: {
      lead: 'يُحسب الإنفاق المتوقع للعملاء خلال الأشهر الـ12 القادمة من سجل طلباتهم بنموذج قابل للتفسير (بلا ذكاء اصطناعي ولا خدمة خارجية). تُحدَّث البيانات مع حساب RFM (كل ليلة).',
      empty: 'لا توجد بيانات عملاء محسوبة بعد',
      emptyLead: 'تظهر هنا بعد حساب RFM في شاشة شرائح العملاء.',
      summaryTitle: 'الملخص',
      computedAt: 'آخر حساب',
      customers: 'العملاء',
      modeledOf: 'عملاء لديهم توقع: {{modeled}} / {{total}}',
      total: 'إجمالي الإنفاق المتوقع خلال 12 شهرًا (العملاء الحاليون)',
      repeatRate: 'معدل الشراء المتكرر',
      repeatUnknown:
        'لا يوجد توقع للعملاء ذوي الطلب الواحد (يلزم {{min}} عميلًا على الأقل؛ العدد الحالي {{count}})',
      repeatValue: '{{rate}}% · الفاصل الوسيط بين طلبات العملاء المتكررين {{days}} يومًا',
      top10: 'حصة أعلى 10% من العملاء قيمةً من الإنفاق المتوقع',
      cac: 'تكلفة الاكتساب عبر الإعلانات (آخر 90 يومًا)',
      cacValue: '{{cac}} لكل عميل جديد · القيمة المتوقعة للعميل الجديد خلال 12 شهرًا {{ltv}}',
      segmentsTitle: 'حسب الشريحة',
      segment: 'الشريحة',
      avgHistoric: 'متوسط الإنفاق السابق',
      avgPredicted: 'متوسط الإنفاق المتوقع (12 شهرًا)',
      topTitle: 'العملاء الأعلى قيمةً متوقعة',
      hiddenName: 'عميل (لا تملك صلاحية رؤية الأسماء)',
      orders: 'الطلبات: {{count}}',
      predictedLine: '{{value}} · ~{{orders}} طلب',
      customerCell: 'القيمة المتوقعة (12 شهرًا)',
      customerCellSub: 'يُتوقع ~{{orders}} طلب · يُشرح النموذج في شاشة قيمة العميل',
    },
    settings: {
      statusTitle: 'الحالة',
      statusLead:
        'الذكاء الاصطناعي خدمة خارجية مدفوعة. حتى بعد إدخال المفتاح، لا يُرسل أي طلب حتى تحدد حد الإنفاق الشهري وتمنح موافقة صريحة.',
      on: 'مفعّل',
      off: 'متوقف',
      enabledBy: 'فعّله {{name}} بتاريخ {{date}}',
      textProvider: 'النص (Anthropic Claude)',
      imageProvider: 'الصور (OpenAI Images)',
      toIntegrations: 'أدخل المفتاح من شاشة التكاملات',
      enable: 'تفعيل الذكاء الاصطناعي',
      disable: 'إيقاف',
      disabled: 'تم إيقاف الذكاء الاصطناعي. لن تنشأ أي رسوم ما لم يكن هناك طلب قيد التنفيذ.',
      enableTitle: 'تفعيل الذكاء الاصطناعي',
      enableLead:
        'عند التفعيل يمكن للمستخدمين المخوّلين إنشاء مسودات، ويتقاضى المزوّد (Anthropic/OpenAI) رسومًا عن كل طلب. ويتوقف النظام عند بلوغ الحد الشهري.',
      enableLimit: 'حد الإنفاق الشهري (USD)',
      enableLimitHint: 'لا تُرسل طلبات جديدة عندما يبلغ الإنفاق التقديري هذا المبلغ. 1 USD على الأقل.',
      enableAck: 'أؤكد أن هذه خدمة مدفوعة، وأن الرسوم تُدفع للمزوّد، وأن الإنفاق سيبقى ضمن الحد.',
      enableProviderNote:
        'نوصي بتحديد حد إنفاق في لوحة المزوّد نفسه أيضًا (Anthropic Console، حدود OpenAI): فحدّ النظام قائم على التقدير.',
      enableSubmit: 'أوافق، فعِّل',
      enabled: 'تم تفعيل الذكاء الاصطناعي.',
      monthTitle: 'هذا الشهر',
      spent: 'الإنفاق التقديري',
      spentOf: '{{spent}} / {{limit}}',
      noLimit: 'لم يُحدَّد حد',
      requests: 'الطلبات',
      requestsToday: 'اليوم {{count}} / {{limit}}',
      estimateNote:
        'المبالغ تقديرات محسوبة من أعداد الـ token وجدول الأسعار أدناه؛ والمبلغ الدقيق هو ما تتضمنه فاتورة المزوّد.',
      configTitle: 'الإعدادات',
      monthlyLimit: 'حد الإنفاق الشهري (USD)',
      dailyLimit: 'الحد اليومي للطلبات',
      textModel: 'نموذج النصوص',
      lightModel: 'نموذج المهام القصيرة',
      lightModelHint: 'يُستخدم في المهام القصيرة مثل العناوين والأوصاف التعريفية والنصوص البديلة (أرخص).',
      imageModel: 'نموذج الصور',
      imageQuality: 'جودة الصور',
      imageQualities: { low: 'منخفضة', medium: 'متوسطة', high: 'عالية' },
      imageReserve: 'الحد الأعلى لكل صورة (USD)',
      imageReserveHint:
        'المبلغ المحجوز قبل طلب الصورة؛ ويُعتبر هو التكلفة إذا لم يُبلغ المزوّد عن عدد الـ token.',
      supportDrafts: 'إرسال رسالة العميل في مسودات ردود الدعم',
      supportDraftsHint:
        'تُخفى عناوين البريد الإلكتروني وأرقام الهواتف وأرقام الهوية وأرقام IBAN وأرقام البطاقات؛ ولا يمكن استبعاد الأسماء والعناوين. قبل التفعيل، حدّث مع محاميك سجل نقل البيانات إلى الخارج وفق KVKK وإشعار الخصوصية.',
      save: 'حفظ الإعدادات',
      saved: 'تم حفظ الإعدادات.',
      pricesTitle: 'جدول الأسعار',
      pricesLead:
        'أُخذت الأسعار الافتراضية من صفحات أسعار المزوّدين بتاريخ {{date}}. إذا غيّر أحد المزوّدين أسعاره فحدّثها من هنا.',
      model: 'النموذج',
      kind: 'النوع',
      kinds: { text: 'نص', image: 'صورة' },
      inputPrice: 'الإدخال / مليون token',
      outputPrice: 'الإخراج / مليون token',
      custom: 'سعر مخصص',
      unknownPrice: 'لا يوجد سعر',
      editPrice: 'تعديل السعر',
      resetPrice: 'العودة إلى الافتراضي',
      priceTitle: 'سعر {{model}}',
      priceSaved: 'تم حفظ السعر.',
      usageTitle: 'الاستخدام',
      usageLead: 'كل طلب أُرسل إلى المزوّد. لا يُحفظ نص الموجِّه (Prompt) ولا نص الرد.',
      month: 'الشهر',
      totals: 'الطلبات: {{requests}} · الناجحة: {{ok}} · الأخطاء: {{errors}} · {{cost}}',
      tokens: 'token الإدخال: {{input}} / token الإخراج: {{output}}',
      byPurpose: 'حسب الغرض',
      purpose: 'الغرض',
      cost: 'التكلفة',
      recent: 'آخر الطلبات',
      when: 'الوقت',
      user: 'المستخدم',
      status: 'النتيجة',
      masked: 'المُخفاة',
      claims: 'الادعاءات الصحية',
      noUsage: 'لا توجد طلبات هذا الشهر.',
      system: 'النظام',
    },
  },
  integrationMessages: {
    youtube_ok: 'تم التحقق من المفتاح (قُرئت قائمة المناطق؛ وحدة حصة واحدة، مجانًا).',
    youtube_key_format: 'صيغة مفتاح API غير صحيحة (يبدأ بـ «AIza» ويتكون من 39 حرفًا).',
    youtube_key_invalid: 'لم تقبل Google مفتاح API هذا.',
    youtube_key_restricted: 'قيد المتصفح/التطبيق على المفتاح يمنع استخدامه من الخادم (استخدم قيد IP).',
    youtube_api_disabled: 'واجهة YouTube Data API v3 غير مفعّلة في مشروع Google Cloud.',
    youtube_quota: 'استُنفدت الحصة اليومية لـ YouTube.',
    youtube_unreachable: 'تعذّر الوصول إلى YouTube.',
    ai_text_ok: 'تم التحقق من المفتاح (قُرئت قائمة النماذج؛ دون أي رسوم).',
    ai_image_ok: 'تم التحقق من المفتاح (قُرئت قائمة النماذج؛ دون أي رسوم).',
    ai_invalid_key: 'رفض المزوّد مفتاح API.',
    ai_invalid_settings: 'مفتاح API فارغ أو بصيغة غير صالحة.',
    ai_provider_rate_limited: 'تم بلوغ حد الطلبات لدى المزوّد؛ أعد المحاولة بعد قليل.',
    ai_provider_overloaded: 'المزوّد مشغول حاليًا؛ أعد المحاولة بعد قليل.',
    ai_provider_rejected: 'رفض المزوّد الطلب.',
    ai_provider_timeout: 'لم يستجب المزوّد في الوقت المحدد.',
    ai_provider_unreachable: 'تعذّر الوصول إلى المزوّد.',
    ai_provider_bad_response: 'تعذّرت قراءة رد المزوّد.',
  },
  integrations: {
    ai_text: {
      name: 'الذكاء الاصطناعي (نص) — Anthropic Claude',
      description:
        'أوصاف المنتجات، ومسودات المقالات والبريد الإلكتروني، والترجمة، وCopilot. خدمة مدفوعة؛ ويتطلب استخدامها موافقة المالك وحدًا شهريًا في إعدادات الذكاء الاصطناعي.',
    },
    ai_image: {
      name: 'الذكاء الاصطناعي (صور) — OpenAI Images',
      description:
        'صور الغلاف وصور المحتوى للمقالات. خدمة مدفوعة؛ ويتطلب استخدامها موافقة المالك وحدًا شهريًا في إعدادات الذكاء الاصطناعي.',
    },
    youtube: {
      name: 'YouTube Data API',
      description:
        'معلومات مقاطع فيديو المنتجات والمدونة (الصورة المصغّرة، المدة، حالة النشر): بيانات الفيديو المنظَّمة في واجهة المتجر، وإخفاء مقاطع الفيديو المحذوفة والتنبيه إليها. قراءة فقط، مفتاح API؛ حصة يومية مجانية.',
    },
  },
  permissions: {
    'ai.generate': 'إنشاء مسودات بالذكاء الاصطناعي (خدمة مدفوعة)',
    'ai.usage.read': 'عرض استخدام الذكاء الاصطناعي وتكلفته',
    'ai.settings.manage': 'تفعيل الذكاء الاصطناعي وإيقافه وتحديد حد الإنفاق',
  },
  permissionModules: { ai: 'الذكاء الاصطناعي' },
  integrationFields: { organizationId: 'معرّف المؤسسة (اختياري، org-…)' },
  auditActions: {
    'seo.keywords_clustered': 'طُبّقت عناقيد الكلمات المفتاحية',
    'catalog.product.merchant_title': 'تم تغيير عنوان منتج Google',
    'file.ai_generated': 'أُنشئت صورة بالذكاء الاصطناعي',
    'file.provenance_update': 'تم تحديث معلومات مصدر الصورة وترخيصها',
    'article_project.create': 'تم إنشاء مشروع مقال',
    'article_project.update': 'تم تحديث مشروع مقال',
    'article_project.archive': 'تمت أرشفة مشروع مقال',
    'article_project.exported': 'نُقل مشروع مقال إلى المدونة',
    'article_project.ai_step': 'خطوة ذكاء اصطناعي في مشروع مقال',
    'article_project.sources_checked': 'تم التحقق من مصادر المقال',
    'article_project.duplicates_checked': 'تم فحص تكرار المقال',
    'ai.enabled': 'تم تفعيل الذكاء الاصطناعي',
    'ai.disabled': 'تم إيقاف الذكاء الاصطناعي',
    'ai.settings_update': 'تم تحديث إعدادات الذكاء الاصطناعي',
    'recommendations.settings_update': 'تم تحديث إعدادات التوصيات',
    'recommendations.recomputed': 'أُعيد حساب التوصيات',
    'forecast.settings_update': 'تم تحديث إعدادات توقع الطلب',
    'forecast.variant_update': 'تم تحديث إعداد التوقع للمتغير',
  },
};
